module.exports = __webpack_public_path__ + "img/ViewOption(Button).72dd60e1.svg";